import { ResponseInterceptor } from 'app/services/api/interfaces';
import { AxiosError, AxiosResponse } from 'axios';
import { apiToastError } from 'modules/utils';

const PLATFORM_LINKING_CODES = [7404, 7405, 7406, 7407, 7408];
const IGNORE_CODES = [10404, ...PLATFORM_LINKING_CODES];
const IGNORE_URLS = ['/active-match'];

export const errorMessageInterceptor: ResponseInterceptor = {
  onFulfilled: (res: AxiosResponse) => Promise.resolve(res),
  onRejected: (err: AxiosError) => {
    const response = err?.response;
    const isAuthStatus = response?.status === 401;
    const isIgnoredUrl = IGNORE_URLS.find((url) => response?.config?.url?.includes(url));
    const isIgnoredCode = IGNORE_CODES.includes(response?.data?.responseCode);

    if (!isAuthStatus && !isIgnoredCode && !isIgnoredUrl) {
      apiToastError(err);
    }

    return Promise.reject(err);
  },
};
